<template>
  <v-container fluid>
    <v-row class="text-center" justify="center">
      <v-col cols="12" sm="8" md="7">
        <v-card class="elevation-12" max-width="800" min-width="400">
          <v-toolbar dark color="primary">
            <v-col>
              <v-toolbar-title>
                {{ $t('Комиссия по итогам торговых процедур') }}
              </v-toolbar-title>
            </v-col>
          </v-toolbar>
          <v-card-text>
            <v-progress-linear :active="isLoading" color="loader" indeterminate />
            <general-error v-if="!!generalError" />
            <ValidationObserver ref="report" @keydown.native.enter="focusOnBtn('getReportxlsxBtn')">
              <validatable-date-picker
                  v-model="params.startIntervalDate"
                  rules="required"
                  :title="$t('По дате завершения последней торговой сессии')"
                  :label="$t('Дата начала периода')" />
              <validatable-date-picker
                  v-model="params.endIntervalDate"
                  rules="required"
                  :title="$t('По дате завершения последней торговой сессии')"
                  :label="$t('Дата окончания периода')" />
            </ValidationObserver>
          </v-card-text>
          <v-card-actions>
            <v-btn
                id="getReportxlsxBtn"
                ref="getReportxlsxBtn"
                v-test="{ btn: 'getReportxlsx' }"
                color="primary"
                :disabled="isLoading"
                @click.stop="getXLSXReport">
              {{ $t('Получить отчет Excel') }}
            </v-btn>
            <v-btn
                v-if="false"
                id="getReportxmlBtn"
                ref="getReportxmlBtn"
                v-test="{ btn: 'getReportxml' }"
                color="primary"
                :disabled="isLoading"
                @click.stop="getXMLReport">
              {{ $t('Получить отчет Xml') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import GeneralError from '../../../reused/common/GeneralError.vue'
  import ValidatableDatePicker from '../../../reused/ui/ValidatableDatePicker.vue'
  import { mapActions } from 'vuex'
  import { REPORTS } from '@/constants/store.js'
  import { FILE_TYPES } from '@/constants/business.js'

  export default {
    components: {
      GeneralError,
      ValidatableDatePicker
    },
    data () {
      return {
        isLoading: false,
        params: {
          startIntervalDate: this.$moment().format('YYYY-MM-DDTHH:mm:ss'),
          endIntervalDate: this.$moment().format('YYYY-MM-DDTHH:mm:ss'),
          fileType: null
        }
      }
    },
    methods: {
      ...mapActions(REPORTS.NAMESPACE, {
        getLotCommissionReportAction: REPORTS.ACTIONS.GET_LOT_COMMISSION_REPORT
      }),
      getXMLReport: async function () {
        await this.getReport(FILE_TYPES.XML)
      },
      getXLSXReport: async function () {
        await this.getReport(FILE_TYPES.XLSX)
      },
      getReport: async function (fileType) {
        const result = await this.$refs.report.validate()
        if (!result) {
          return
        }
        try {
          this.params.fileType = fileType
          this.isLoading = true
          await this.getLotCommissionReportAction(this.params)
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
